import React, { useState } from "react";
import {
  Grid, Paper, makeStyles, InputAdornment, IconButton,
  FormControl, InputLabel, OutlinedInput,
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import CloseIcon from "@material-ui/icons/Close";

const useStyles = makeStyles((theme) => ({
  root: { padding: theme.spacing(2), justifyContent: "flex-end" },
  search: { width: "100%", maxWidth: 400 },
}));

function OrderSearch({ handleSearch, reset, label = "Search by Name" }) {
  const classes = useStyles();
  const [inp, setInp] = useState("");

  return (
    <Grid item container component={Paper} elevation={0} className={classes.root}>
      <form className={classes.search} onSubmit={(event) => {
        event.preventDefault();
        handleSearch(inp);
      }}>
        <FormControl variant="outlined" size="small" fullWidth>
          <InputLabel htmlFor="order-name-search">{label}</InputLabel>
          <OutlinedInput
            id="order-name-search"
            value={inp}
            onChange={(event) => setInp(event.target.value)}
            endAdornment={
              <InputAdornment position="end">
                <IconButton type="submit" aria-label="Search orders" size="small">
                  <SearchIcon />
                </IconButton>
                <IconButton type="button" aria-label="Clear search" size="small" onClick={() => {
                  setInp("");
                  reset();
                }}>
                  <CloseIcon />
                </IconButton>
              </InputAdornment>
            }
            label={label}
          />
        </FormControl>
      </form>
    </Grid>
  );
}

export default OrderSearch;
